export const environment = {
  production: true,
  apiUrl: 'https://api.soundcafe.grdev.pw/api', // global API URL
  InterceptorSkipHeaderImage: 'X-Interceptor-Image',
  url: 'https://client.soundcafe.grdev.pw'
};
